module.exports = "mat-card-content{\r\n     margin-left: 45px;\r\n}\r\n\r\n"